import { render, staticRenderFns } from "./pagination2.vue?vue&type=template&id=5f711098&scoped=true&"
import script from "./pagination2.vue?vue&type=script&lang=js&"
export * from "./pagination2.vue?vue&type=script&lang=js&"
import style0 from "./pagination2.vue?vue&type=style&index=0&id=5f711098&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f711098",
  null
  
)

export default component.exports